import Radio from '@material-ui/core/Radio';

import { ReactComponent as FolderBlueUser } from '../../../../images/folder-blue-user.svg';
import { ReactComponent as FolderBlue } from '../../../../images/folder-blue.svg';
import { ReactComponent as MyFolderViolet } from '../../../../images/my-folder-violet.svg';

interface IChooseFolderLineProps {
  folder: IFolder;
}
function ChooseFolderLine({ folder }: IChooseFolderLineProps) {
  const folderDisplay = () => {
    if (folder.isDefault) {
      return <MyFolderViolet />;
    }

    const colCount = folder.totalCollaborators ?? 0;

    if (colCount > 0) {
      return <FolderBlueUser />;
    } else if (colCount === 0) {
      return <FolderBlue />;
    }
  };

  return (
    <div className="chose-folder-line">
      <Radio value={folder.idIri} />
      {folderDisplay()}
      <span>{`${folder.name}`}</span>
    </div>
  );
}

export default ChooseFolderLine;
